import { pathOr } from "ramda";

export const getLicenses = material => ({
  userlicenses: pathOr({}, ["userlicenses"], window.getClientConfiguration()),
  partOfLicenses: pathOr("", ["partOfLicences"], material)
    .split(",")
    .map(lic => lic.trim())
    .filter(lic => lic.length > 0)
});

export function isUnavailableInDemo(material) {
  const { inDemo } = (material);

  

  const isDemo = window.getClientConfiguration(false, [
    "book",
    "settings",
    "licensetype_settings",
    "features",
    "isdemo"
  ]);

  const demofullforgroup = window.getClientConfiguration(false, [
    "book",
    "settings",
    "licensetype_settings",
    "features",
    "demofullforgroup"
  ]);
  const isDemoFullForGroup = window.getClientConfiguration([], ["profile", "groups"]).includes(demofullforgroup);

  return isDemo && !isDemoFullForGroup && !inDemo;
}

export const hasMissingUserLicense = material => {
  const { userlicenses, partOfLicenses } = getLicenses(material);

  if (isUnavailableInDemo(material)) return true;
  if (partOfLicenses.length === 0) return false;
  for (let license of partOfLicenses) {
    if (userlicenses.hasOwnProperty(license)) return false;
  }
  return true;
};
